import {Routes} from '@/src/config/routes'

import {PageTransformFn} from '@/src/core/domain/page/functions/types'
import {PageType} from '@/src/core/domain/entities/page'
import {parseHTMLContent} from '@/src/shared/modules/html-snippets/parse'
import React from 'react'
import {NewsDetailPageContent} from '../../../../../../../web/src/(pages)/news/screen.detail'

export const newsTransform: PageTransformFn = async function (data, session, isMobile) {
  data.breadcrumbs = data.breadcrumbs.map(breadcrumb => ({
    ...breadcrumb,
    url: (breadcrumb.url && Routes.news.section.page(breadcrumb.url, isMobile)) || undefined,
  }))

  if (data.breadcrumbs.length > 0) {
    data.breadcrumbs.unshift({
      title: 'Новости',
      url: Routes.news.page,
    })
  }

  if (data.type == PageType.NewsDetail) {
    if (isMobile) {
      // @ts-ignore TODO: исправить
      data.suspense = {
        content: <NewsDetailPageContent promise={parseHTMLContent(data.content.news.detail.text)} />,
      }
    }
  }

  return data
}
